import { render, staticRenderFns } from "./partnership.vue?vue&type=template&id=573b2add&"
import script from "./partnership.vue?vue&type=script&lang=js&"
export * from "./partnership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Partnership: require('/var/www/app/components/Partnership.vue').default})
